var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pending-table-container",staticStyle:{"max-height":"100%","min-height":"100%","overflow-x":"scroll","overflow-y":"hidden"}},[_c('div',{staticStyle:{"width":"100%","color":"gray","font-weight":"400","font-size":"15px","margin":"10px auto","font-family":"Poppins"}}),_c('TableComponent',{attrs:{"columns":_vm.columns,"height":"52vh","tableData":_vm.pendingList,"isLoading":_vm.isLoading,"objectList":_vm.filterFields},on:{"tableFilter":() => {
        _vm.tableFilterRequestHandler();
      },"resetFilter":() => {
        _vm.resetFilter();
      },"applicationViewer":_vm.pendingApplicationViewer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }